var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrossCancelCloseIconType1Light = function SvgCrossCancelCloseIconType1Light(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 10.002l6.285-6.285a1 1 0 10-1.412-1.412L9.998 8.59 3.713 2.305A.999.999 0 002.3 3.717l6.285 6.285L2.3 16.287A1 1 0 103.713 17.7l6.285-6.285 6.285 6.285a.996.996 0 001.412 0 .999.999 0 000-1.413l-6.285-6.285z",
    fill: "#000"
  })));
};
export default SvgCrossCancelCloseIconType1Light;